exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header[data-v-d2697308] {\n  background-color: #17a2b8; /* Bootstrap info color */\n  color: white;\n}\n.card-header[data-v-d2697308] {\n  background-color: #17a2b8;\n  color: white;\n}\n.card[data-v-d2697308] {\n  margin-bottom: 20px;\n}\n.btn-danger[data-v-d2697308] {\n  background-color: #f06292;\n  border-color: #f06292;\n}\n", ""]);

// exports
